import React from "react";
import {Banner, List, Page} from "@shopify/polaris";
import {useHistory} from "react-router-dom";

const NoMatch = () => {
    const router = useHistory();
    return (<Page fullWidth={true}>
        <Banner
            title="ERROR 404 NOT FOUND"
            action={{
                content: "Go to dashboard",
                onAction: () => {
                    router.push('/');
                },
            }}
            status="warning"
        >
            <List>
                <List.Item>
                    You may have mis-typed the URL. Or the page has been removed. Actually, there is nothing to see
                    here... Click on the link below to do something, Thanks!
                </List.Item>
            </List>
        </Banner>
    </Page>);
}

export default NoMatch;
